import { Chip, makeStyles } from "@material-ui/core";
import { findLast } from "lodash";
import moment from "moment";

interface IPassengerStatusChip {
  status: string;
  logs: IAssignmentPassengerLog[];
}

const useStyles = makeStyles({
  chip: {
    width: "100%",
    color: "#FFFFFF",
    fontWeight: 600,
    marginBottom: 5,
    backgroundColor: (props: any) => {
      switch (props.status) {
        case "ON THE BUS":
          return "#00A042";
        case "ALIGHT":
          return "#046AC8";
        case "ABSENT":
          return "#EEA415";
        case "NOT TAKING":
          return "#EF0C0C";
        case "EXCLUDE STUDENT":
          return "#999999";
        case "NOT STARTED":
          return "#E0E0E0";
        default:
          return;
      }
    },
  },
});

const PassengerStatusChip = ({ status, logs }: IPassengerStatusChip) => {
  const classes = useStyles({ status });

  const getStatusName = (status: string) => {
    switch (status) {
      case "EXCLUDE STUDENT":
        return "NOT TAKING (EXCLUDED)";
      case "ABSENT":
        const findLog = findLast(logs, ["type", "absented"]);

        if (!findLog) {
          return "ABSENT";
        }

        const loggedAt = moment(findLog.loggedAt).format("hh:mm A");

        return `ABSENT - ${loggedAt}`;
      default:
        return status;
    }
  };

  return (
    <Chip size="small" label={getStatusName(status)} className={classes.chip} />
  );
};

export default PassengerStatusChip;
